import { styled } from "@pigment-css/react";

export const Divider = styled("hr")(({ theme }) => ({
  width: "100%",
  height: theme.strokeWidth.thin,
  margin: 0,
  border: "none",
  background: theme.fieldSalesTwo.colors.neutral[200],
}));
